import { UnitProgressConfig } from './config';

export class UnitStateChangeEvent {
	constructor(public config: UnitProgressConfig) {}
}
